module.exports = __webpack_public_path__ + "img/RedirectSiteIcon.d3e68086.svg";